import { useRef, useCallback } from "react";

export function useClickThrottle(
    callback,
    delay = 5000
) {
    const lastClickRef = useRef(0);

    return useCallback(
        (...args) => {
            const now = Date.now();

            if (now - lastClickRef.current < delay) return;

            lastClickRef.current = now;
            callback(...args);
        },
        [callback, delay]
    );
}
